import {Invoice} from '@eitje/api'
import _ from 'lodash'

export const useInvoiceNumberFilter = () => {
	const invoices = Invoice.useAll().whereNot({status: ['paid', 'disregard']})

	const uniqueItems = _.orderBy(_.uniq(invoices._map('formatted_invoice_number')), [], ['desc'])
	const items = uniqueItems.map(item => ({id: item, value: item}))

	const filterFn = (item, filterValues) => {
		return filterValues.includes(item.formatted_invoice_number)
	}

	return {
		items,
		filterFn,
		labelField: 'value',
	}
}
